import { render, staticRenderFns } from "./ListWardPage.vue?vue&type=template&id=55bb58f0&"
import script from "./ListWardPage.vue?vue&type=script&lang=js&"
export * from "./ListWardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports